"use client";

import { useEffect } from "react";
import { Home, RefreshCw, TriangleAlert } from "lucide-react";
import { usePrefs } from "@/components/prefs-provider";
import { Button, ButtonLink } from "@/components/ui/button";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { t } = usePrefs();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen bg-bg">
      <main id="main-content" className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-warn-soft text-warn-ink">
          <TriangleAlert className="h-8 w-8" aria-hidden />
        </span>
        <h1 className="mt-6 font-display text-3xl font-bold tracking-tight text-ink">{t.errors.errorTitle}</h1>
        <p className="mt-3 leading-relaxed text-ink-2">{t.errors.errorBody}</p>
        {error.digest ? <p className="ltr mt-2 font-mono text-xs text-ink-3">{error.digest}</p> : null}
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button onClick={reset} icon={<RefreshCw className="h-4 w-4" aria-hidden />}>
            {t.errors.tryAgain}
          </Button>
          <ButtonLink href="/" variant="outline" icon={<Home className="h-4 w-4" aria-hidden />}>
            {t.errors.goHome}
          </ButtonLink>
        </div>
      </main>
    </div>
  );
}
